/**
 * Contains all the data points related to fileprovider services
 */
export default {
    GetAccessToken: {
        datapoint: {
            name: 'getAccessToken',
            customData: (actionSource: string) => ({
                actionSource: actionSource,
            }),
        },
    },
};
